import { defineComponent as _defineComponent } from 'vue'
import MailChecker from 'mailchecker'



export default /*#__PURE__*/_defineComponent({
  __name: 'EmailInput',
  emits: ['validate'],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const emit = __emit

const checkEmail = (e) => {
  const result = MailChecker.isValid(e.target.value)
  emit('validate', result)
}

const __returned__ = { emit, checkEmail, get MailChecker() { return MailChecker } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})